module.exports = __webpack_public_path__ + "static/media/butler-opening-cardoor.0946df9a.jpg";